import React, { useEffect, useState, useRef } from 'react';
import GamificationData from 'services/dataService/GamificationData';
import { useForm, Controller } from 'react-hook-form';
import MaterialTable, { MTableToolbar } from 'material-table';
import { makeStyles } from '@material-ui/core/styles';
import { CardContent, Grid, Button, TextField, FormControl } from '@material-ui/core';
import { toast } from 'react-toastify';
import { Select, MenuItem } from "@mui/material";
import { localizationTable, options } from 'constants/table';
import { Search } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { format, parseISO } from 'date-fns';
import { useSelector } from 'react-redux';


const useStyles = makeStyles({
    container: {
        padding: '20px 5px',
        display: 'flex',
        alignItems: 'center',
    },
    table: {
        width: '100%',
        maxWidth: '800px',
        borderCollapse: 'collapse',
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    },
    thead: {
        backgroundColor: '#176AE6',
        color: '#fff',
    },
    th: {
        padding: '12px 20px',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    tbody: {
        '& tr:nth-child(even)': {
            backgroundColor: '#f9f9f9',
        },
        '& tr:hover': {
            backgroundColor: '#f1f1f1',
        },
    },
    td: {
        padding: '12px 20px',
        textAlign: 'center',
        fontSize: '16px',
        color: '#333',
    },
    rank: {
        fontWeight: 'bold',
        color: '#333',
    },
    score: {
        fontWeight: 'bold',
        color: '#176AE6',
    },
});

const ReportsTable = () => {
    const classes = useStyles();
      const { id } = useSelector((state) => state.auth);
    
    const [userRewards, setUserRewards] = useState([]);
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState('all');
    const [filter, setFilter] = useState('');

    const { t } = useTranslation([
        'label',
        'toastify',
        'tables',
        'form',
        'button',
        'validation',
    ]);
    const { register, handleSubmit, control } = useForm();
    const tableRef = useRef();


    const handleFetch = async () => {
        try {
            const response = await GamificationData.getUserRewards({
                filter,
                status,
                isExport: true,
            });
            return response.data;
        } catch (err) {
            toast.error(
                'Não foi possível buscar os dados do relatório, tente novamente mais tarde.'
            );
            return [];
        }
    };

    const onSubmit = (data) => {
        setFilter(data.filter);
        setStatus(data.status);

        tableRef.current.state.query.page = 0;
        tableRef.current.onQueryChange();
    };

    const handleUpdateStatusGamification = async (rewardId, newStatus, item) => {
        try {
            await GamificationData.updateStatusGamification(rewardId, newStatus, item, id)
            tableRef.current.onQueryChange();
        } catch (error) {
            console.error("Erro ao atualizar status:", error);
        }
    };

    return (
        <>
            <div className='notranslate'>
                <MaterialTable
                    title={`Relatório de Resgates`}
                    tableRef={tableRef}
                    columns={[
                        {
                            title: 'Nome',
                            field: 'user.name',
                            render: (rowData) => rowData?.user.name,
                        },
                        {
                            title: `E-mail`,
                            field: `user.email`,
                            render: (rowData) => rowData?.user.email,
                        },
                        {
                            title: `CPF`,
                            field: `user.cpf`,
                            render: (rowData) => rowData?.user.cpf,
                        },
                        {
                            title: `Resgate`,
                            field: `reward.name`,
                            render: (rowData) => rowData?.reward.name,
                        },
                        {
                            title: 'Qtd.',
                            field: `quantity`,
                            render: (rowData) => rowData?.quantity,
                        },
                        {
                            title: 'Custo',
                            field: `reward.cost`,
                            render: (rowData) => rowData?.reward.cost,
                        },
                        {
                            title: 'Status',
                            field: `status_rescue`,
                            render: (rowData) => (
                                <Select
                                    value={rowData.status_rescue || ""}
                                    onChange={(e) =>
                                        handleUpdateStatusGamification(rowData.id, e.target.value, rowData?.reward.name)
                                    }
                                    size="small"
                                    sx={{
                                        color:
                                            rowData.status_rescue === "Resgatado"
                                                ? "green"
                                                : rowData.status_rescue === "Negado"
                                                    ? "red"
                                                    : "orange",
                                        fontWeight: "bold",
                                        minWidth: '125px'
                                    }}
                                >
                                    <MenuItem value="Pendente" sx={{ color: "orange" }}>
                                        Pendente
                                    </MenuItem>
                                    <MenuItem value="Resgatado" sx={{ color: "green" }}>
                                        Resgatado
                                    </MenuItem>
                                    <MenuItem value="Negado" sx={{ color: "red" }}>
                                        Negado
                                    </MenuItem>
                                </Select>
                            ),
                        },
                        {
                            title: 'Data Resgate',
                            field: `data_rescue`,
                            render: (rowData) => {
                                if (rowData.data_rescue) {
                                    return format(
                                        parseISO(rowData?.data_rescue),
                                        'dd/MM/yyyy HH:MM:SS'
                                    );
                                } else {
                                    return '';
                                }
                            },
                        },
                    ]
                    }
                    data={async (query) => {
                        try {
                            const response = await GamificationData.getUserRewards({
                                page: query.page + 1,
                                limit: query.pageSize,
                                filter: filter,
                                status
                            });

                            let { rewards, currentPage, totalCount } = response.data;

                            return {
                                data: rewards,
                                page: currentPage - 1,
                                totalCount,
                            };
                        } catch (err) {
                            toast.error(t('toastify:commons.toast_error_api'));
                            return { data: [] };
                        }
                    }}
                    components={{
                        search: true,
                        title: true,
                        Toolbar: (props) => (
                            <div>
                                <MTableToolbar {...props} />
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <CardContent>
                                        <Grid container spacing={3}>
                                            <Grid item md={6} xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label={t('form:commons.input_search')}
                                                    name="filter"
                                                    type="text"
                                                    variant="outlined"
                                                    defaultValue={filter || ''}
                                                    inputRef={register}
                                                />
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <FormControl style={{ minWidth: 100 }}>
                                                    <Controller
                                                        as={
                                                            <Select>
                                                                <MenuItem value="all">
                                                                    Todos
                                                                </MenuItem>
                                                                <MenuItem value="Pendente">
                                                                    Pendente
                                                                </MenuItem>
                                                                <MenuItem value="Resgatado">
                                                                    Resgatado
                                                                </MenuItem>
                                                                <MenuItem value="Negado">
                                                                    Negado
                                                                </MenuItem>
                                                            </Select>
                                                        }
                                                        name="status"
                                                        control={control}
                                                        defaultValue={status ? status : 'all'}
                                                        value={'all'}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item md={3} xs={12} className={classes.actions}>
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    size="large"
                                                    type="submit"
                                                >
                                                    {t('button:User_solictation.btn_advanced_filter')}
                                                    <Search />
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </form>
                            </div>
                        ),
                    }}
                    localization={localizationTable(t)}
                    options={{
                        ...options,
                        exportFileName: "RewardsRescue",
                        exportButton: true,
                        exportCsv: () => {
                            GamificationData.getUserRewards({ page: 1, limit: 999999, filter, status: "all" }).then((response) => {
                                const data = response.data.rewards.map(reward => ({
                                    Nome: reward?.user?.name,
                                    Email: reward?.user?.email,
                                    CPF: reward?.user?.cpf,
                                    Resgate: reward?.reward.name,
                                    Qtd: reward?.quantity,
                                    Custo: reward?.reward.cost,
                                    Status: reward?.status_rescue,
                                    DataResgate: format(
                                        parseISO(reward?.data_rescue),
                                        'dd/MM/yyyy HH:MM:SS'
                                )}));
                        
                                const csvRows = [];
                                const headers = Object.keys(data[0]);
                                csvRows.push(headers.join(','));
                        
                                for (const row of data) {
                                    csvRows.push(headers.map(h => `"${row[h]}"`).join(','));
                                }
                        
                                const csvString = csvRows.join('\n');
                                const blob = new Blob([csvString], { type: 'text/csv' });
                                const url = window.URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.setAttribute('hidden', '');
                                a.setAttribute('href', url);
                                a.setAttribute('download', 'RewardsRescue.csv');
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                        });
                        }
                    }}
                />
            </div>
        </>
    );
};

export default ReportsTable;

